export function isEmptyOrSpaces(str) {
    return str === null || str.toString().match(/^ *$/) !== null;
}
